$('.continuous-scroll').slick({
  slidesToShow: 1,
  slidesToScroll: 1,  
  autoplay: true,
  autoplaySpeed: 0,
  speed: 15000,
  pauseOnHover: false,
  arrows: false,
  dots: false,
  rtl: false,
  cssEase: 'linear'
});

$('.continuous-scroll-rtl').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  //cssEase: 'linear',
  autoplay: true,
  autoplaySpeed: 0,
  speed: 15000,
  pauseOnHover: false,
  arrows: false,
  dots: false,
  rtl: true,
  cssEase: 'linear'
});



// Slick Slider
$('.banner-carousel').slick({
    infinite: true,
    autoplay: true,
    autoplaySpeed: 3000,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    dots: true
});



//Product slide
  $('.product-slide').slick({
    dots: false,
    autoplay: true,
    pauseOnHover: false,
    autoplaySpeed: 3000,
    slidesToShow: 3,
    slidesToScroll: 1,  
    infinite: true,
    cssEase: 'linear',
    //prevArrow: '<img src="images/arrow-left-large.svg" class="left-arrow-gallery">',
    //nextArrow: '<img src="images/arrow-right-large.svg" class="right-arrow-gallery">',
    arrows: false,  
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          arrows: false,
          dots: false
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          arrows: false,          
          dots: false
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,          
          infinite: true,
          dots: false
        }
      }     
    ]
  });



//  Three Slide
$('.three-slide').slick({
    dots: false,
    infinite: true,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 3,    
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: true
        }
      }     
    ]
  });

//  Four Slide
$('.four-slide').slick({
    dots: false,
    infinite: true,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 4,    
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: true
        }
      }     
    ]
  });



  //footer-gallery-scroll
$('.footer-gallery-scroll').slick({
    dots: false,
    infinite: true,
    autoplaySpeed: 1000,
    slidesToShow: 4,
    slidesToScroll: 4, 
    arrows: false,       
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: false
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          infinite: true,
          dots: false
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          infinite: true,
          dots: false
        }
      }     
    ]
  });


 //testimonials-scroll
$('.testimonials-scroll').slick({
    dots: false,
    infinite: true,
    speed: 300,
    prevArrow: '<img src="https://cdn.shopify.com/s/files/1/0611/5429/6043/files/arrow-left-large.svg?v=1655925593" class="left-arrow">',
    nextArrow: '<img src="https://cdn.shopify.com/s/files/1/0611/5429/6043/files/arrow-right-large.svg?v=1655925593" class="right-arrow">',
    slidesToShow: 1,
    slidesToScroll: 1,    
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: false
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: true
        }
      }     
    ]
  });



//middle-banner-scroll
$('.middle-banner-scroll').slick({
    dots: false,
    autoplay: true,
    infinite: true,
    speed: 200,
    prevArrow: '<img src="https://cdn.shopify.com/s/files/1/0611/5429/6043/files/arrow-left-large.svg?v=1655925593" class="left-arrow-middle">',
    nextArrow: '<img src="https://cdn.shopify.com/s/files/1/0611/5429/6043/files/arrow-right-large.svg?v=1655925593" class="right-arrow-middle">',
    slidesToShow: 1,
    slidesToScroll: 1,    
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: false
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: false
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: false
        }
      }     
    ]
  });


//product-gallery
$('.product-gallery').slick({
    dots: false,
    infinite: true,
    speed: 300,
    prevArrow: '<img src="https://cdn.shopify.com/s/files/1/0611/5429/6043/files/arrow-left-large.svg?v=1655925593" class="left-arrow-gallery">',
    nextArrow: '<img src="https://cdn.shopify.com/s/files/1/0611/5429/6043/files/arrow-right-large.svg?v=1655925593" class="right-arrow-gallery">',
    slidesToShow: 1,
    slidesToScroll: 1,    
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: false
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: false
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: false
        }
      }     
    ]
  });
// search start
  $(".search-btn").click(function(){        
    $(".search-section").animate({top:'0px'}, 300);  
    $(".search-envelop-icon").focus();
  });
$(".close-search").click(function(){  
    $(".search-section").animate({top:'-350px'}, 300);  
  });



 //dropdown-btn
 var dropdown = document.getElementsByClassName("dropdown-btn");
var i;

for (i = 0; i < dropdown.length; i++) {
  dropdown[i].addEventListener("click", function() {
  this.classList.toggle("activemobile-menu");
  var dropdownContent = this.nextElementSibling;
  if (dropdownContent.style.display === "block") {
  dropdownContent.style.display = "none";
  } else {
  dropdownContent.style.display = "block";
  }
  });
}

//mySidenav
 function openNav() {
  document.getElementById("mySidenav").style.width = "100%";
}

function closeNav() {
  document.getElementById("mySidenav").style.width = "0";
}



//sticky
// window.onscroll = function() {myFunction()};

// var header = document.getElementById("myHeader");
// var sticky = header.offsetTop;

// function myFunction() {
//   if (window.pageYOffset > sticky) {
//     header.classList.add("sticky");
//   } else {
//     header.classList.remove("sticky");
//   }
// }



//AOS Animation

 jQuery('.subscribe-modal-close').click(function(){
      // $(".gt-cookies-box").hide();
        $.cookie('AcceptCookie', 'closed', { path: '/', expires: 720 / 1440 });
   $(".subscribe-modal").fadeOut(200);  
    });
